import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Detectify extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M20.889,11.014c.01-.123.016-.249.016-.377A4.6,4.6,0,0,0,17.6,6.263l-.085-1.655.469-2.332-3.105,0V4.339H13.42V2.274H10.6V4.339H9.146V2.274l-3.1,0,.469,2.332L6.364,7.5a2.932,2.932,0,0,0-2.581,2.872,2.84,2.84,0,0,0,.244,1.151,4.1,4.1,0,1,0,.2,8.2H19.389A4.546,4.546,0,0,0,24,15.249,4.482,4.482,0,0,0,20.889,11.014Zm-4.375,3.131a2.642,2.642,0,0,0-1.992.453,2.6,2.6,0,0,0-3.626-.2A2.461,2.461,0,0,0,8.761,13.8a2.619,2.619,0,0,0-2.178-.762L7.013,4.6l0-.032L6.654,2.776H8.646V4.839H11.1V2.774H12.92V4.839h2.455V2.775h2L17.008,4.57l.418,8.189A2.645,2.645,0,0,0,16.514,14.145Z" />
        <path d="M8.24,7.8a3.762,3.762,0,0,0,7.52,0V7.719H8.24ZM12,7.954A1.477,1.477,0,1,1,10.479,9.43,1.5,1.5,0,0,1,12,7.954Z" />
      </svg>
    );
  }
}

export default Detectify;
